<header>
  <nav class="navbar fixed-top navbar-expand-md navbar-dark navbar-main">
    <div class="float-left">
      <a href="/"><span class="navbar-brand navbar-heading pl-md-1 pl-lg-5"
          style="border-right: 0px;">zeszyt.online</span></a>
    </div>
    <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarTogglerDemo01"
      aria-controls="navbarTogglerDemo01" aria-expanded="false" aria-label="Toggle navigation">
      <span class="navbar-toggler-icon"></span>
    </button>
    <div class="collapse navbar-collapse" id="navbarTogglerDemo01">
      <ul class="navbar-nav mr-auto mt-2 mt-md-0 ml-md-2">
      </ul>
      <div class="form-inline pr-lg-5 pr-md-1">
        <a [routerLink]="['/logowanie']" class="btn custom-button heading-button default-button ml-1 mt-2 mt-md-0">zaloguj
          się!</a>
      </div>
    </div>
  </nav>
</header>
